export default "__VITE_ASSET__CWEvDGlw__"